<template>
    <v-card class="barchart-card d-flex flex-column flex-grow-1" min-width="80%" :style="cardInlineStyle">
        <v-card-title>
            {{ phrase.barchart_card_title }}
        </v-card-title>
        <v-card-text class="chart-container flex-grow-1 pa-0">
            <div class="chart-wrap">
                <Chart :chartData="chartData" :options="options" />
            </div>
        </v-card-text>
    </v-card>
</template>

<script>
import words from '../assets/words.json'
import Chart from './barchart.vue'

import { FINANCE_LIMIT_ITEMS as CHART_LIMIT_ITEMS, financeUpperRate } from '../utils/finance-limits'

export default {
    components: {
        Chart
    },
    props: {
        forceHeight: {
            type: Number,
            default: null
        }
    },
    data() {
        return {
            options: {
                responsive: true,
                maintainAspectRatio: false,
                layout: {
                    padding: {
                        left: 8,
                        right: 12,
                        top: 0,
                        bottom: 4
                    }
                },
                legend: {
                    display: true
                },
                scales: {
                    'xAxes': [{
                        'stacked': 'true',
                        'scaleLabel': {
                            'display': 'true',
                            'labelString': '費目'
                        },
                        'ticks': {
                            'fontSize': 12
                        }
                    }],
                    'yAxes': [{
                        'stacked': 'true',
                        'scaleLabel': {
                            'display': 'true',
                            'labelString': 'NMI [%]'
                        },
                        'ticks': {
                            'beginAtZero': 'true',
                            'stepSize': 2,
                            'fontSize': 12
                        }
                    }]
                },
                tooltips: {
                    enabled: false
                }
            },
            phrase: {},
        }
    },
    computed: {
        cardInlineStyle() {
            if (!this.forceHeight) return {}
            return {
                height: `${this.forceHeight}px`,
                maxHeight: `${this.forceHeight}px`
            }
        },
        chartData () {
            const loginResponse = this.$store.state.login_response || {}
            const labels = CHART_LIMIT_ITEMS.map((item) => item.label)

            const lowerData = CHART_LIMIT_ITEMS.map((item) => {
                const limit = loginResponse[`limits_${item.key}`] || {}
                return this.toNumber(limit.lower_limit, item.lower)
            })

            const upperDiffData = CHART_LIMIT_ITEMS.map((item, index) => {
                const limit = loginResponse[`limits_${item.key}`] || {}
                const upperRaw = financeUpperRate(item, this.$store.state.target, this.toNumber(limit.upper_limit, item.upperRaw))
                const lower = lowerData[index]
                return Math.max(upperRaw - lower, 0)
            })

            return {
                labels,
                datasets: [
                    {
                        label: "下限",
                        data: lowerData,
                        fill: true,
                        backgroundColor: '#FFAA66',
                    },
                    {
                        label: "上限",
                        data: upperDiffData,
                        fill: true,
                        backgroundColor: '#ffcc66',
                    }
                ]
            }
        }
    },
    mounted: function () {
        this.getWords()
    },
    methods: {
        toNumber(value, fallback) {
            const n = Number(value)
            return Number.isFinite(n) ? n : fallback
        },
        getWords: function () {
            this.phrase = words
        }
    }
}
</script>

<style scoped>
.barchart-card {
  /* Prevent any child (canvas) from painting outside the card */
  overflow: hidden;
}

/* v-card-text: make it a flex container and include padding in its own box */
.chart-container {
  min-height: 0;            /* important for flex children */
  display: flex;
  flex-direction: column;
  padding: 8px 16px 12px;
  box-sizing: border-box;
  overflow: hidden;
}

/* Chart area takes the remaining space inside the padded container */
.chart-wrap {
  flex: 1 1 auto;
  min-height: 0;
  height: 100%;
  width: 100%;
  overflow: hidden;
}
</style>
